import React, { Component } from 'react';
import { Spin, Table, Tooltip, Button, Card, Icon, Col, Row, Select, DatePicker, Tag } from 'antd';
import { FileExcelOutlined } from '@ant-design/icons';
import { sanitizerTexto, getStatusInv, getStatusInvColor  } from '../../util/utilerias';
import { openNotification } from '../../util/notificaciones';
import CatalogoRequest from '../../services/Catalogo';
import { get_id } from '../../util/IdUser';
import { ShowMenuItem } from '../../util/ShowMenuItem';
import InventarioRequest from '../../services/Inventario';
import FormHistoricoInventario from './FormHistoricoInventario';
import moment from 'moment'
import * as ExcelJS from 'exceljs';
import { saveAs } from 'file-saver';
import 'moment/locale/es';
import { roles } from '../../util/Roles';
import dayjs from 'dayjs';
import { esBarras, getSegmento } from '../../util/generics';
moment.locale('es')
const rol = localStorage.getItem("role")?.split(",");
const { Option } = Select
const { RangePicker } = DatePicker;
const dateFormat = 'DD/MM/YYYY';
const userId = localStorage.getItem("id_user");

/**
 * Clase para ver el proceso historico de inventario
 */
export default class HistoricoInventario extends Component {
    state = {
        arrHistoricoInventario: [],
        filterText: "",
        cargando: false,
        bloquear_guardar: true,
        arrDrives: [],
        allDrives: [],
        drivesSelected: [],
        scroll: { x: 1250, y: 470 },
        disable_combo_drive: false,
        typeForm: null,
        objInventario: null,
        paginacion: {},
        visible: false,
        dateStrings: [],
        fecha_historico: [],
        disableRange: true,
        paginaSiguiente: 1,
        arrStatus: [
            { idStatus: 0, nombre: "Borrador" },
            { idStatus: 1, nombre: "Pendiente facturación" },
            { idStatus: 2, nombre: "Validar Reconteo" },
            { idStatus: 3, nombre: "Procesando" },
            { idStatus: 4, nombre: "Pendiente SAP" },
            { idStatus: 5, nombre: "Finalizado" }
        ],
        statusSelected: [],
        disableApplyFilters: true,
        filtros: {
            id_drives: undefined,
            dateStrings: undefined,
            statusSelected: undefined,
            page: undefined
        },
        firstDate:null,
    }

    /**
     * Comportamiento del componente al mostrar el historico de inventarios
     */
    componentDidMount = () => {
        let state = { ...this.state };
        const segmento = getSegmento()
        if((!ShowMenuItem([roles.Admin]) && userId != 16) || !segmento || esBarras() ){
            const location = {
                pathname: "/",
            }
            this.setState(state, this.props.history.push(location))
        }else{
            CatalogoRequest.CargarSitiosByUsuario(get_id()).then(response => {
                state.arrDrives = response.data
                state.allDrives = response.data.map(f => f.id);
                
                if(state.arrDrives.length){
                    state.arrDrives.unshift({id: -1, plaza: 0, cr: 'TODOS', nombre: 'TODOS', plaza_nombre: 'TODOS'})
                } else {
                    state.arrDrives.unshift({id: -1, plaza: 0, cr: 'No hay resultados', nombre: 'No hay resultados', plaza_nombre: 'No hay resultados', disable:true})
                }
                this.setState(state)
            }).catch(err => {
                openNotification(
                    "Ha ocurrido un error al listar los puntos de venta del usuario.",
                    "Error"
                )
            })
        }
    }

    /**
     * Función que se ejecuta cuando el usuario introduce algo en la barra de búsqueda
     * @param: value. valor de la búsqueda
     * @return: nada. se establece un nuevo valor para la el texto a filtrar.
     */
    filterText = (value) => {
        let state = { ...this.state };
        state.filterText = value;
        let arrEquivalenciasCopy = state.arrEquivalencias
        if (value) {
            arrEquivalenciasCopy = arrEquivalenciasCopy.filter(obj => {
                return sanitizerTexto(value, obj.articulo.codigo)
                    || sanitizerTexto(value, obj.articulo.descripcion)
            })
        }
        state.arrEquivalenciasCopy = arrEquivalenciasCopy
        this.setState(state);
    }

    /**
     * Se ejecuta cuando se busca en el input text
     */
    handleSearchInput = (text) => {
        let state = { ...this.state };
        state.filterText = text;
        this.setState(state);

        clearTimeout(state.timer)
        state.timer = setTimeout(() => {
            this.applyFilters();
        }, 1000);
    }

    filtrarBtn = (info) => {
        let state = { ...this.state };
        this.setState({ cargando: true }, () => {
            if (state.drivesSelected) {
                if(state.drivesSelected[0] == "-1" && state.drivesSelected.length == 1){
                    state.filtros.drive_id = state.allDrives;
                }else{
                    state.filtros.drive_id = state.drivesSelected;
                }
                state.filtros.dateStrings = state.dateStrings;
                state.filtros.statusSelected = state.statusSelected;
                InventarioRequest.ListarHistoricoInventario(state.filtros.drive_id, state.dateStrings, state.statusSelected).then(response => {
                    state.paginacion = {
                        current: 1,
                        total: response.data.count,
                        onChange: this.handlePaginaChange,
                        pageSize: 100,
                        showTitle: false
                    }
                    response.data.results.find((item) => {
                        item.Fecha2 = new Date(item.Fecha);
                        item.Fecha2.setHours(item.Fecha2.getHours() + 7);
                    });

                    state.bloquear_guardar = false;
                    state.cargando = false;
                    state.arrHistoricoInventario = response.data.results
                    state.disableRange = false;
                    this.setState(state)
                }).catch(err => {
                    this.setState({ cargando: false });
                    openNotification(
                        "Ha ocurrido un error al listar el histórico del drive seleccionado.",
                        "Error"
                    )
                })
            } else {
                state.cargando = false;
                state.paginacion.total = 0;
                state.arrHistoricoInventario = [];
                state.disableRange = false;
                state.dateStrings = [];
                state.fecha_historico = [];
                this.setState(state)
            }
        })
    }

    /**
     * Se ejecuta cuando hay un cambio en combo de drive
     */
    onChangeDrive = (value) => {
        let state = { ...this.state };
        if (!value.length) {
            state.drivesSelected = [];
            state.disableApplyFilters = true;
            state.disableRange = true;
            state.dateStrings = [];
            state.fecha_historico = [];
        } else {
            state.drivesSelected = value
            state.disableRange = false;
        }
        state.arrHistoricoInventario = [];

        this.setState(state)
    }

    /**
    * Función que se ejecuta cuando se cambia el rangepicker
    * @param: dates. valores  del rangepicker
    * @param: dateStrings. valores en formato string de la fecha
    * @return: nada
    */
    onChangeRange = (dates, dateStrings) => {
        let state = { ...this.state };
        state.dateStrings = dateStrings;
        state.fecha_historico = dates;
        state.arrHistoricoInventario = [];
        if (!dates.length) {
            state.disableApplyFilters = true;
        } else {
            state.disableApplyFilters = false;
        }
        this.setState(state);
    }

    handleChangeStatus = (value) => {
        let state = { ...this.state }
        state.arrHistoricoInventario = [];
        if (!value.length) {
            state.statusSelected = [];
        } else {
            state.statusSelected = value
        }

        this.setState(state)
    }

    /**
     * Función que se ejecuta cuando se da clic en página siguiente
     * @param: paginaSiguiente. valor de la página siguiente
     * @return: nada. se establece un nuevo valor para la el texto a filtrar.
     */
    handlePaginaChange = (paginaSiguiente) => {
        let state = { ...this.state };
        state.paginaSiguiente = paginaSiguiente
        this.setState({ cargando: true }, () => {
            if (state.drivesSelected) {
                InventarioRequest.ListarHistoricoInventario(state.filtros.drive_id, state.dateStrings, state.statusSelected, paginaSiguiente).then(response => {
                    state.paginacion = {
                        current: paginaSiguiente,
                    }

                    response.data.results.find((item) => {
                        item.Fecha2 = new Date(item.Fecha);
                        item.Fecha2.setHours(item.Fecha2.getHours() + 7);
                    });
                    state.bloquear_guardar = false;
                    state.cargando = false;
                    state.arrHistoricoInventario = response.data.results
                    state.disableRange = false;
                    this.setState(state)
                }).catch(err => {
                    this.setState({ cargando: false });
                    openNotification(
                        "Ha ocurrido un error al listar el histórico del drive seleccionado.",
                        "Error"
                    )
                })
            }
        })
    }

    /**
     * Mostrarl el modal de formulario de inventario
     * @param: type. acción que elige el usuario entre ver o editar
     * @param: record. objecto de inventario seleccionado
     * @return: nada, se usa el valor para mostrar datos específicos
     */
    showForm = (type, _, record) => {
        this.setState({ typeForm: type, objInventario: record, visible: true })
    }

    /**
     * Función para esconder modal de detalle de inventario
     * @param: value. true o false
     * @return: nada
     */
    esconderModal = (value) => {
        let state = { ...this.state }
        state.visible = false;
        state.objInventario = null;
        this.setState(state, () => {
            if (value) this.onChangeDrive()
        })
    }

    disabledFutureDates = (current) => {
        // Disable dates after today
        return current && current > dayjs().endOf('day');
    }

    exportExcel(){
        let driveSel = this.state.arrDrives.find(dr => dr.id == this.state.drivesSelected)
        let today = new Date();
        let customString = `${today.getFullYear()}-${(today.getMonth() + 1).toString().padStart(2, '0')}-${today.getDate().toString().padStart(2, '0')}`;

        let fileName = "Historial " + driveSel.nombre + " " + customString;

        // Ejemplo de uso:
        const datos = [];
        this.state.arrHistoricoInventario.map((obj, index) => {
            datos.push({
                Drive: obj.sitio,
                Fecha: obj.Fecha2,
                Refencia: obj.Refencia,
                FolioSAP: obj.FolioSAP,
                Estatus: getStatusInv(obj.Estatus),
                Diferencia: obj.Diferencia,
                Sobrante: obj.Sobrante,
                Faltante: obj.Faltante
            })
        })
        
        // 1. Crear el libro y la hoja de trabajo
        const workbook = new ExcelJS.Workbook();
        const worksheet = workbook.addWorksheet('Historial');

        // 2. Agregar columnas y filas de datos
        worksheet.columns = [
            { header: 'Drive', key: 'Drive', width: 42 },
            { header: 'Fecha', key: 'Fecha', width: 12, style: { numFmt: '[$-c0a]dd"-"mm"-"yyyy', alignment: {horizontal: 'center' } }
            },
            { header: 'Refencia', key: 'Refencia', width: 17 },
            { header: 'FolioSAP', key: 'FolioSAP', width: 18 },
            { header: 'Estatus', key: 'Estatus', width: 10 },
            { header: 'Diferencia', key: 'Diferencia', width: 13 },
            { header: 'Sobrante', key: 'Sobrante', width: 13 },
            { header: 'Faltante', key: 'Faltante', width: 13, style: { numFmt: '$#,##0;[Red]-$#,##0'} },
        ];

        
        worksheet.getCell('A1').alignment = {horizontal: 'center' };
        worksheet.getCell('A1').font = { bold: true };
        worksheet.getCell('B1').font = { bold: true };
        worksheet.getCell('C1').alignment = {horizontal: 'center' };
        worksheet.getCell('C1').font = { bold: true };
        worksheet.getCell('D1').alignment = {horizontal: 'center' };
        worksheet.getCell('D1').font = { bold: true };
        worksheet.getCell('E1').alignment = {horizontal: 'center' };
        worksheet.getCell('E1').font = { bold: true };
        worksheet.getCell('F1').alignment = {horizontal: 'center' };
        worksheet.getCell('F1').font = { bold: true };
        worksheet.getCell('G1').alignment = {horizontal: 'center' };
        worksheet.getCell('G1').font = { bold: true };
        worksheet.getCell('H1').alignment = {horizontal: 'center' };
        worksheet.getCell('H1').font = { bold: true };
        
        // Set Column 3 to Currency Format
        worksheet.getColumn(6).numFmt = '$#,##0;[Red]-$#,##0';
        worksheet.getColumn(7).numFmt = '$#,##0;[Red]-$#,##0';
        //worksheet.getColumn(8).numFmt = '$#,##0;[Red]-$#,##0';

        worksheet.addRows(datos);

        // 3. Escribir el workbook en un buffer (como un blob)
        workbook.xlsx.writeBuffer().then(r => {
            const buffer = r;
            // 4. Usar 'file-saver' para descargar el blob
            const blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
            saveAs(blob, fileName + '.xlsx');
        }).catch(err => {
            console.log(err)
            openNotification(
                "Ha ocurrido un error al generar el archivo de Excel.",
                "Error"
            )
        })
    }

    render() {
        const columnasInventario = [
            {
                title: "Fecha y hora de captura",
                dataIndex: "Fecha2",
                key: "Fecha2",
                render: fecha => {
                    return ( <span> {moment(fecha).format("DD/MM/YYYY, h:mm a")} </span> )
                }
            },
            {
                title: "Drive",
                dataIndex: "sitio",
                key: "sitio",
                render: sitio => {
                    return ( <span> {sitio} </span> )
                }
            },
            {
                title: "Estado",
                dataIndex: "Estatus",
                key: "Estatus",
                render: (value) => {
                    return (
                        <span style={{fontWeight: "bold", color: getStatusInvColor(value)}}> {getStatusInv(value)}</span>
                    )
                }
            },
            {
                title: "Inventario Número",
                dataIndex: "Refencia",
                key: "Refencia",
                render: Refencia => {
                    return ( <span> {Refencia} </span> )
                }
            }
        ]

        return (
            <Card id="ParentSize"
                title="Histórico de inventario auxiliar"
            >
                <div className="panel-block">
                    <div style={{ marginBottom: "20px" }}>
                        <Row gutter={[16]} >
                            <Col span={5}>
                                <Tooltip placement="top" title="Punto de venta">
                                    <div className="center">Punto de venta:</div>
                                    <Select
                                        defaultActiveFirstOption={false}
                                        allowClear={this.state.arrDrives?.length > 1}
                                        showSearch
                                        disabled={this.state.disable_combo_drive}
                                        notFoundContent={"No hay opciones"}
                                        style={{ width: "100%" }}
                                        placeholder="Seleccionar..."
                                        optionFilterProp="children"
                                        filterOption={(input, option) => sanitizerTexto(input, option.props.children)}
                                        value={this.state.drivesSelected}
                                        mode="multiple"
                                        onChange={this.onChangeDrive}
                                        //onChange={(value) => {
                                        //    this.setState({ driveSelected: value }, this.onChangeDrive)
                                        //}}
                                    >
                                        <Option key={0} value={null} disabled={true}>Seleccionar...</Option>
                                        {
                                            this.state.arrDrives?.length > 0 &&
                                            this.state.arrDrives.map((obj, index) => {
                                                return (
                                                    <Option
                                                        key={obj.id}
                                                        value={obj.id}>
                                                        {obj.nombre}
                                                    </Option>
                                                )
                                            })
                                        }
                                    </Select>
                                </Tooltip>
                            </Col>
                            <Col span={6}>
                                <Tooltip placement="top" title="Rango de fecha">
                                    <div className="center">Rango de fecha:</div>
                                    <RangePicker
                                        format={ dateFormat }
                                        placeholder={["Fecha inicial", "Fecha final"]}
                                        value={ this.state.fecha_historico }
                                        disabled={ this.state.disableRange }
                                        ranges={{
                                            'Última Semana': [moment().subtract(6, 'days').startOf('day'), moment()],
                                            'Último Mes': [moment().subtract(29, 'days').startOf('day'), moment()],
                                            'Último Año': [moment().subtract(365, 'days').startOf('day'), moment()]
                                        }}
                                        onOpenChange={(open)=>{
                                            if(open){
                                                this.setState({firstDate:null})
                                            }
                                        }}
                                        //disabledDate={d => d.isSameOrBefore(moment().subtract(730, 'days').startOf('day'))}
                                        disabledDate={(current)=>{
                                            let state = {...this.state}
                                            let firstDateClone = moment(JSON.parse(JSON.stringify(state.firstDate)));
                                            return state.firstDate ? state.firstDate > current || current > firstDateClone.add(31, 'day') :false;
                                        }}
                                        onChange={(dates, dateStrings) => {
                                            this.onChangeRange(dates, dateStrings);
                                        }}
                                        onCalendarChange={(dates,dateStrings,info)=>{
                                            const firstDate = dates[0];
                                            let firstDateClone = moment(JSON.parse(JSON.stringify(firstDate)));
                                            this.setState({firstDate:firstDate,fecha_historico:[firstDate,firstDateClone.add(31,'day')]});
                                        }}
                                    />
                                </Tooltip>
                            </Col>
                            <Col span={8}>
                                <Tooltip placement="top" title="Estatus">
                                    <div className="center">Estatus:</div>
                                    <Select id="select-status-modulo"
                                        showSearch
                                        style={{ width: "100%" }}
                                        defaultActiveFirstOption={false}
                                        notFoundContent='No hay opciones'
                                        placeholder="Seleccionar..."
                                        optionFilterProp="children"
                                        mode="multiple"
                                        onChange={this.handleChangeStatus}
                                        value={this.state.statusSelected}
                                        allowClear
                                    >
                                        <Option value={null} disabled={true}>Seleccionar...</Option>
                                        {
                                            this.state.arrStatus.length > 0 &&
                                            this.state.arrStatus.map(obj => {
                                                return (
                                                    <Option
                                                        key={obj.idStatus}
                                                        value={obj.idStatus}
                                                        disabled={obj.disable}>

                                                        {obj.nombre}
                                                    </Option>
                                                )
                                            })
                                        }
                                    </Select>
                                </Tooltip>
                            </Col>
                            <Col span={2}>
                                <Tooltip placement="top" title={this.state.drivesSelected.length ? "Realizar búsqueda" : ""}>
                                    <Button
                                        id="boton-filtrar-productos-filtros"
                                        className={this.state.disableApplyFilters ? "disableBtn" : ""}
                                        type={this.state.disableApplyFilters ? "default" : "primary"}
                                        icon="search"
                                        style={{ width: '80%', marginLeft: '2.5%', marginBottom: "30px", marginTop: '1.7em' }}
                                        onClick={() => {
                                            this.setState({ paginaSiguiente: 1 }, this.filtrarBtn)
                                        }}
                                    >
                                    </Button>
                                </Tooltip>
                            </Col>
                        </Row>
                    </div>
                    <Spin
                        tip="Cargando..."
                        indicator={<Icon type="loading" style={{ fontSize: 24, color: "#e0cbae" }} spin />}
                        spinning={this.state.cargando}
                        style={{ color: "#e0cbae", backgroundColor: "rgb(255,255,255,0.8)" }}>
                        <Table size="small"
                            locale={{ emptyText: 'No se han encontrado resultados' }}
                            rowKey={(_, index) => index}
                            columns={columnasInventario}
                            dataSource={this.state.arrHistoricoInventario}
                            pagination={this.state.paginacion}
                            scroll={{ y: 600 }}
                        />
                    </Spin>
                </div>
                <FormHistoricoInventario
                    esconderModal={this.esconderModal}
                    visible={this.state.visible}
                    type={this.state.typeForm}
                    inventario={this.state.objInventario}
                    drive_selected={this.state.drivesSelected}
                />
            </Card>
        )
    }
}